module.exports = __webpack_public_path__ + "img/product.a398f115.svg";